const PlanBuilderPage = () => {
  return (
    <div className="container-custom section-padding">
      <h1 className="text-3xl font-bold mb-8">Plan Builder</h1>
      <div className="bg-white p-8 rounded-lg shadow-md">
        <p className="text-gray-600">Plan builder coming soon...</p>
      </div>
    </div>
  )
}

export default PlanBuilderPage
